import { render, staticRenderFns } from "./PosterGrayGrid.vue?vue&type=template&id=197c9622&scoped=true&"
import script from "./PosterGrayGrid.vue?vue&type=script&lang=js&"
export * from "./PosterGrayGrid.vue?vue&type=script&lang=js&"
import style0 from "./PosterGrayGrid.vue?vue&type=style&index=0&id=197c9622&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197c9622",
  null
  
)

export default component.exports